// How a review policy reads in one line.
import type { OrgSettings } from '../api/server';

/** "Merging allowed · briefs from any https: origin", from the policy's own values. */
export function policySummary(p: OrgSettings): string {
  const merging = p.allow_merge ? 'Merging allowed' : 'Merging not allowed';
  const briefs = p.brief_origins.length ? p.brief_origins.join(', ') : 'any https: origin';
  return `${merging} · briefs from ${briefs}`;
}

/**
 * Why the settings API answered 404 for `owner`'s policy: asked directly,
 * the viewer is no member of it (or it does not exist); asked through
 * `repo` (`?repo=`), the viewer cannot read that repository.
 */
export function policyNotFoundText(owner: string, repo?: string): string {
  return repo ? `You can't read ${owner}/${repo}, or it does not exist.` : `You are not a member of ${owner}, or it does not exist.`;
}
